<template>
  <main>
    <CreatorCenterCarousel
      v-if="entryResolved"
      :joining="joining"
      @join="startJoining"
    />

    <el-dialog
      custom-class="creator-join-guide-dialog"
      title="加入创作者中心前，请完成以下准备"
      :visible.sync="guideVisible"
      width="1120px"
      top="0"
      :close-on-click-modal="false"
      append-to-body>
      <img
        class="creator-join-guide-image"
        :src="creatorJoinGuideImage"
        alt="登录注册、实名认证和校园认证指引">
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="joining"
          :disabled="joining"
          @click="continueJoining">
          我已知晓，马上行动
        </el-button>
      </span>
    </el-dialog>
  </main>
</template>

<script>
import CreatorCenterCarousel from '@/components/creator-carousel/CreatorCenterCarousel.vue'
import creatorJoinGuideImage from '@/assets/images/creatorCarousel/creator-join-guide.png'
import request from '@/tool/request'
import API from '@/tool/api'
import { getAccessToken } from '@/tool/authStorage'
import {
  getResultData,
  getResultError,
  getResultMessage,
  isResultSuccess,
} from '@/tool/result'
import realNameCertification from '@/tool/realNameCertification.cjs'

const {
  isRealNameStatusResponse,
  normalizeRealNameStatus,
} = realNameCertification

export default {
  name: 'CreatorIntro',

  components: {
    CreatorCenterCarousel
  },

  data() {
    return {
      creatorJoinGuideImage,
      entryResolved: false,
      guideVisible: false,
      joining: false,
    }
  },

  created() {
    this.resolveCreatorEntry()
  },

  methods: {
    hasActiveSession() {
      return Boolean(getAccessToken())
    },
    loadRealNameStatus() {
      return request.get(API.user.realNameVerification.status)
        .then((response) => {
          if (!isResultSuccess(response)) {
            throw getResultError(response, '实名认证状态查询失败')
          }
          const statusData = getResultData(response)
          if (!isRealNameStatusResponse(statusData)) {
            throw new Error('实名认证状态无效，请稍后重试')
          }
          return normalizeRealNameStatus(statusData)
        })
    },
    resolveCreatorEntry() {
      if (!this.hasActiveSession()) {
        this.entryResolved = true
        return
      }

      this.loadRealNameStatus()
        .then((realNameStatus) => {
          if (realNameStatus.status !== 'APPROVED') {
            this.entryResolved = true
            return null
          }
          return request.get(API.creatorCenter.membership)
        })
        .then((response) => {
          if (!response) return
          if (!isResultSuccess(response)) {
            throw getResultError(response, '创作者中心入口查询失败')
          }
          if (getResultData(response) && getResultData(response).joined === true) {
            this.$router.replace({ name: 'creatorCenter' })
            return
          }
          this.entryResolved = true
        })
        .catch((error) => {
          this.entryResolved = true
          this.$message.error(getResultMessage(error, '创作者中心入口查询失败，请稍后重试'))
        })
    },
    startJoining() {
      if (!this.hasActiveSession()) {
        this.guideVisible = true
        return
      }

      this.joining = true
      this.loadRealNameStatus()
        .then((realNameStatus) => {
          if (realNameStatus.status !== 'APPROVED') {
            this.guideVisible = true
            return null
          }
          return request.get(API.creatorCenter.membership)
        })
        .then((response) => {
          if (!response) return null
          if (!isResultSuccess(response)) {
            throw getResultError(response, '创作者中心入口查询失败')
          }
          if (getResultData(response) && getResultData(response).joined === true) {
            this.$router.replace({ name: 'creatorCenter' })
            return null
          }
          return request.post(API.creatorCenter.join)
        })
        .then((response) => {
          if (!response) {
            return
          }
          if (!isResultSuccess(response)) {
            throw getResultError(response, '加入创作者中心失败')
          }
          this.guideVisible = false
          this.$router.replace({ name: 'creatorCenter' })
        })
        .catch((error) => {
          this.$message.error(getResultMessage(error, '加入创作者中心失败，请稍后重试'))
        })
        .finally(() => {
          this.joining = false
        })
    },
    continueJoining() {
      this.guideVisible = false
      if (!this.hasActiveSession()) {
        this.$router.push({
          name: 'login',
          query: { redirect: '/center/basic' },
        })
        return
      }
      this.$router.push('/center/basic')
    },
  }
}
</script>

<style>
.el-dialog.creator-join-guide-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(1120px, calc(100vw - 32px), calc((100vh - 180px) * 1.772)) !important;
  max-height: calc(100vh - 32px);
  margin: 0 !important;
  border-radius: 20px;
  overflow: hidden;
  transform: translate(-50%, -50%);
}

.el-dialog.creator-join-guide-dialog .el-dialog__body {
  padding: 12px 20px 4px;
  overflow: hidden;
}

.creator-join-guide-image {
  display: block;
  width: 100%;
  max-height: calc(100vh - 180px);
  margin: 0 auto;
  object-fit: contain;
}

.el-dialog.creator-join-guide-dialog .el-dialog__footer {
  padding: 0 0 50px;
  text-align: center;
}

.el-dialog.creator-join-guide-dialog .dialog-footer {
  display: flex;
  justify-content: center;
}

.el-dialog.creator-join-guide-dialog .dialog-footer .el-button {
  min-width: 200px;
  height: 52px;
  border-color: #f49b17;
  border-radius: 999px;
  background: #f49b17;
  box-shadow: 0 15px 36px rgba(244, 155, 23, 0.28);
  font-size: 16px;
  font-weight: 800;
}

.el-dialog.creator-join-guide-dialog .dialog-footer .el-button:hover,
.el-dialog.creator-join-guide-dialog .dialog-footer .el-button:focus {
  border-color: #ef9100;
  background: #ef9100;
}

@media (max-width: 560px) {
  .el-dialog.creator-join-guide-dialog {
    width: min(calc(100vw - 24px), calc((100vh - 162px) * 1.772)) !important;
  }

  .el-dialog.creator-join-guide-dialog .el-dialog__header {
    padding-right: 48px;
  }

  .el-dialog.creator-join-guide-dialog .el-dialog__title {
    font-size: 16px;
  }

  .el-dialog.creator-join-guide-dialog .dialog-footer .el-button {
    min-width: 180px;
    height: 48px;
  }
}
</style>
